import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  root: {},
  colStackedText: {
    lineHeight: '1.4rem',
  },
}))
